export default {
  common: {
    actions: "행위",
    active: "유효한",
    add_success: "추가 된 성공",
    admin_panel: "관리자 패널",
    all: "모든",
    back: "뒤로",
    configuration: "구성",
    continue: "잇다",
    create: "창조하다",
    date_filter: "기간 선택",
    delete_success: "삭제 된 성공",
    delete: "지우다",
    deleted: "{msg} 성공 삭제!",
    description: "기술",
    disabled: "장애인",
    edit: "편집하다",
    enabled: "사용",
    input_filter: "텍스트 입력",
    profile: "윤곽",
    rows_per_page_text: "페이지 당 행 수: ",
    save: "구하다",
    search: "수색",
    select_filter: "옵션을 선택하세요",
    select_one: "하나 이상의 항목을 선택하십시오.",
    status: "지위",
    submit: "복종시키다",
    sure: "확실해?",
    type: "유형",
    update_success: "업데이트 성공",
    use: "이 항목이 사용 중입니다. 새 항목을 만드십시오.",
  },
  form: {
    title: "양식 관리"
  },
  footer: {
    title: "사기 탐지 시스템",
    copy: "인피니그루 회사"
  },
  header: {
    title: "사기 탐지 시스템"
  },
  menu: {
    list: "메뉴 목록"
  },
  route: {
    dashboard: "계기반"
  },
  setting: {
    title: "환경",
    menu_list: "메뉴 목록"
  },
  task: {
    title: "작업 관리"
  },
  timeformat: {
    datetime_example: "날짜 시간 예",
    datetime_format: "날짜 / 시간 형식",
    time_example: "시간 예",
    time_format: "시간 형식",
    title: "날짜 및 시간 형식",
  },
  workflow: {
    title: "워크 플로우 관리"
  },
};
